import React, { useEffect } from 'react';
import {
   Card,
   CardBody,
   Col, Container,
   Row,
} from 'reactstrap';
import avatar from 'assets/img/avatars/userUpward.png';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import SignInForm from './SignInForm';
import config from './config';
import { resolvePostLoginRedirect } from 'util/auth/postLoginRedirect';

const SignInPartner = (props) => {
   const history = useHistory();
   const location = useLocation();

   useEffect(() => {
      if (props.isLoggedInPartner) {
         history.push(resolvePostLoginRedirect(location?.state?.from, config.SUCCESS_LOGIN_URL_REDIRECT));
      }
   }, []);

   return (
      <Container
         className='absolute-center'
         style={{
            // used to cancel out the margin of the .main class
            marginTop: '-3.5rem',
         } }
      >
         <Row>
            <Col sm={12} md={9} lg={6} className='mx-auto'>
               <div className='text-center mt-4'>
                  <h2>Welcome back, </h2>
                  <p className='lead'>
                     Sign in to your&nbsp;
                     <strong style={ { textDecoration: 'underline' } }>Partner</strong>
                     {' '}
                     account to continue
                  </p>
               </div>
               <Card>
                  <CardBody>
                     <div className='m-sm-4'>
                        <div className='text-center'>
                           <img
                              src={ avatar }
                              alt='Icon'
                              className='img-fluid rounded-circle'
                              width='132'
                              height='132'
                           />
                        </div>
                        <SignInForm/>
                     </div>
                  </CardBody>
               </Card>
            </Col>
         </Row>
      </Container>
   );
};

const mapStateToProps = (state) => ({
   isLoggedInPartner: state.authReducer.isLoggedInPartner,
});

export default connect(
   mapStateToProps,
)(SignInPartner);
